import { useAuthorization } from "../AuthorizationContext";

/**
 * Compatibility hook for components that consume the user's privileged role.
 */
export const useUserRoles = () => {
    return useAuthorization();
};
